module.exports = __webpack_public_path__ + "media/images/logo-sage-3ce7207304322a34c2a3ca4107be95e2.png";